var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-sticky',[_c('van-search',{attrs:{"shape":"round","background":"#e93323","placeholder":"请输入搜索关键词"},on:{"search":_vm.onSearch,"clear":_vm.onClear},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }